import { FC, useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import styled from 'styled-components';
import gfm from 'remark-gfm';
import { useNavigate } from '@reach/router';
import { colors } from '../config/theme';
import { problems } from '../data/problems';

interface ScreenProps {
  file: string;
  filter: string;
}

export const Screen: FC<ScreenProps> = ({ file, filter }) => {
  const navigate = useNavigate();

  const [md, setMd] = useState('');
  const [filteredProblems, setFilteredProblems] = useState<typeof problems>([]);

  useEffect(() => {
    fetch(`../screens/${file}`)
      .then((data) => data.text())
      .then(setMd);
  }, [file]);

  useEffect(() => {
    setFilteredProblems(
      problems.filter((problem) => problem.type === filter || filter === '*')
    );
  }, [filter]);

  const goTo = (path: string) => () => {
    navigate(path);
  };

  return (
    <Wrapper>
      <ReactMarkdown plugins={[[gfm]]}>{md}</ReactMarkdown>

      {md && !!filteredProblems.length && (
        <div>
          <h3>Probleme</h3>

          <div className="problems">
            {filteredProblems.map((problem) => (
              <div className="problem-wrapper">
                <div
                  className="problem"
                  onClick={goTo(`/problems/${problem.name}`)}
                >
                  {problem.name}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  margin-left: 400px;
  margin-right: 100px;
  padding-bottom: 50px;
  max-width: 900px;
  text-align: justify;

  color: ${colors.blue_grey_900};

  .problems {
    display: flex;
    flex-wrap: wrap;
  }

  .problem-wrapper {
    width: 25%;
    margin: 10px 10px 10px 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .problem {
    background: ${colors.blue_grey_900};
    color: ${colors.blue_grey_050};
    padding: 20px 30px;
    min-width: 200px;
    border-radius: 8px;

    cursor: pointer;
  }

  h1 {
    letter-spacing: 1.5px;
    font-size: 36px;
    padding-bottom: 50px;
    padding-top: 50px;
    text-align: center;
  }

  h3 {
    font-size: 24px;
    padding-top: 24px;
    line-height: 2;
  }

  h3::before {
    content: '#';
    margin-right: 8px;
    color: ${colors.yellow_vivid_500};
  }

  p,
  ul,
  li {
    padding-left: 24px;
    line-height: 1.5;
    padding-bottom: 5px;
  }

  li > ul {
    padding-left: 12px;
    padding-bottom: 0;
  }

  li::before {
    content: '';
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 100%;
    background: ${colors.yellow_vivid_500};
    margin-right: 10px;
    margin-left: -20px;
  }
`;
